import { TFunction } from "@kazoohr/internationalization";

import { ApolloError } from "../browser";

/**
 * Tries to parse the supplied `error` value as a `KazooError`
 * and extracts the already-translated message from its metadata, or the default
 * message you supply if that can't be achieved.
 *
 * @param defaultMessage The message that will be returned if the error doesn't include a translation string. Usually this should be wrapped in TFunction.
 * @param error The error that may or may not be a KazooError
 */
export function extractMessageFromKazooError(
  defaultMessage: string,
  error: ApolloError | null | undefined,
  t: TFunction
): string {
  let message;
  if (error && error.graphQLErrors) {
    message = error.graphQLErrors.find(
      (gqlErr) => !!gqlErr?.extensions?.translation
    )?.extensions?.translation;

    if (!message) {
      message = error.graphQLErrors.find(
        (gqlErr) => !!gqlErr?.extensions?.translationKey
      )?.extensions?.translationKey;
    }
  }

  if (message) {
    return t(String(message));
  }
  return defaultMessage;
}
